const AppConfig = {
	AppName: "Weave",
	baseUrl: "/",
	apiUrl: "/",
	DOWNLOAD_APP_URL: "http://weavechain.com",
	samplePublicKey:
		"weavee4d9abgaypPw6789h3oKMh8TzXm62sNaADDryq6JY36o",
	samplePrivateKeyFile: "key.pvk",
	generateKeyUrl:
		"https://ukmadcat.com/wp-content/uploads/2019/04/sleepy-cat.jpg",
	PAGE_SIZE: 100, 
	filePreviewTheme: "tomorrow", // pop|railscasts|rjv-default|monokai|tube
	currency: "USDC",
	TERMS_URL: "https://www.weavechain.com/terms-of-service",
	PRIVACY_POLICY_URL: "https://www.weavechain.com/privacy-policy",
	METAMASK_DOWNLOAD_URL: "https://metamask.io/download/",
	UI_URL: "https://ui.weavechain.com",
	MARKETPLACE_URL: "https://market.weavechain.com",
	INSTALLATION_URL: "https://docs.weavechain.com/dockerauto.html",
	POAP_URL: "https://app.poap.xyz",
	LICENSES_URL: "https://spdx.org/licenses/",
	DEMO_MODE: true,
	EARNINGS_STEPS: 5,
};

export default AppConfig;
